import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';

import { Http } from '../../support';
import { useStore } from '../../store';
import ReceptorUpsert from './upsert/ReceptorUpsert';
import Loading from '../../facturotopia/loading/Loading';
import GetNewListHighlighted from '../../support/GetNewListHighlighted';

class ReceptoresUpsert extends Component {
  state = {};

  backfilled: false;

  constructor(props) {
    super(props);

    const { id } = props.match.params;
    const { data = {} } = props.location.state || {};

    const newData = !!data.id ? { ...data, direccion: data.direccion || {} } : { id };

    this.state = {
      id,
      data: newData,
      original: {
        ...newData,
        direccion: undefined,
      },
    };
  }

  async componentDidMount() {
    const { data } = this.state;

    if (!!data.id) {
      this.setState({
        busy: true,
      });

      try {
        const response = await Http.get(`/api/receptores/${data.id}?include=nomina`);

        this.setState({
          original: {
            ...response.data,
            direccion: undefined,
          },
          data: response.data,
          busy: false,
        });
      } catch (error) {
        this.setState({
          error: error.data || error,
          busy: false,
        });
      }
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  handleOnComplete = async (result) => {
    // If result is set up means upsert action was performed
    if (!!result) {
      window.ToastManager.show({
        variant: 'success',
        title: 'Receptores',
        message:
          result.message || (!this.state.data.id ? 'Receptor registrado' : 'Información de Receptor actualizada'),
      });

      const { data } = this.props.list;

      this._highlightUpsertedItem(data, result.data);
    }

    this.props.history.replace('/app/receptores');
  };

  _highlightUpsertedItem = (fullList, data) => {
    const newList = GetNewListHighlighted.make(fullList, data, true);

    this.props.listActions.setPartialState({ data: newList });

    setTimeout(() => {
      const newList = GetNewListHighlighted.make(fullList, data, false);

      this.props.listActions.setPartialState({ data: newList });
    }, 5000);
  };

  render() {
    const { id, data, original, busy } = this.state;

    if (busy) {
      return <Loading />;
    }

    return (
      <>
        <div>
          <div className="page-header">
            <Link to={!!id ? `/app/receptores/${id}/info` : `/app/receptores`}>
              &#8592; {!!id ? `Regresar` : `Receptores`}
            </Link>
          </div>

          <h5>{data.id ? original.razon_social || '...' : 'Nuevo Receptor'}</h5>
        </div>

        <ReceptorUpsert
          id={id}
          data={data}
          onComplete={this.handleOnComplete}
        />
      </>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.receptores.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.receptores.list };
};

export default connect(useStore, mapState, mapActions)(ReceptoresUpsert);
